import styles from './VerticalNavItem.module.css'

import cn from 'clsx'
import React, { useCallback, useState } from 'react'
import { NavLink } from 'react-router-dom'

import Icon from 'components/ui/icon'

export type VerticalNavItemType = {
  active?: boolean
  disabled?: boolean
  expandable?: boolean
  expanded?: boolean
  indent?: number
  items?: VerticalNavItemType[]
  label: React.ReactNode
  link?: string
  onClick?: () => void
}
export const VerticalNavItem = ({
  active,
  disabled,
  expandable,
  expanded,
  indent = 0,
  items,
  label,
  link,
  onClick,
}: VerticalNavItemType): React.ReactNode => {
  const [isExpanded, setIsExpanded] = useState<boolean>(expanded ?? true)
  const Element: React.ElementType = !disabled && link ? NavLink : 'div'
  const linkProps = link ? { to: link } : {}
  let indentNodes: React.ReactNode[] = []

  if (indent) {
    for (let i = 0; i < indent; i++) {
      indentNodes.push(<span className={styles.indent} key={i} />)
    }
  }

  const handleClick = useCallback(() => {
    if (expandable) {
      setIsExpanded((isExpanded: boolean) => {
        if (link || onClick) {
          return true
        }

        return !isExpanded
      })
    }

    if (onClick) {
      onClick()
    }
  }, [expandable, link, onClick])
  const handleExpand = useCallback((event: React.SyntheticEvent<any>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsExpanded((isExpanded: boolean) => !isExpanded)
  }, [])
  return (
    <>
      <Element
        className={cn(styles.component, {
          [styles.clickable]: !disabled && (expandable || link || onClick),
          [styles.disabled]: disabled,
          [styles.expandable]: expandable && items && items.length > 0,
        })}
        onClick={!disabled ? handleClick : undefined}
        {...linkProps}
      >
        {indentNodes}
        {expandable && items && items.length > 0 && (
          <span
            className={styles.expand}
            onClick={!disabled ? handleExpand : undefined}
          >
            <Icon type={isExpanded ? 'arrow-down' : 'arrow-right'} />
          </span>
        )}
        <span className={styles.label}>{label}</span>
      </Element>
      {items &&
        isExpanded &&
        items
          .map((item: VerticalNavItemType) => ({
            ...item,
            disabled: item.disabled ?? disabled,
            indent: indent + 1,
          }))
          .map((item: VerticalNavItemType, index: number) => (
            <VerticalNavItem {...item} key={index} />
          ))}
    </>
  )
}
